const filterFalseyValues = (array) => array.filter((item) => !!item);

export default filterFalseyValues;
